import { render } from "./Periods.vue?vue&type=template&id=40ffc730"
import script from "./Periods.vue?vue&type=script&lang=js"
export * from "./Periods.vue?vue&type=script&lang=js"

import "./Periods.vue?vue&type=style&index=0&id=40ffc730&lang=less"
script.render = render

export default script